import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as smartConnectServices from "../../../services/smartConnect/smartConnect.services.js";

export const getSmartConnectSettings = createAsyncThunk(
  "smartConnectSettings/get",
  async (_, { rejectWithValue }) => {
    try {
      const res = await smartConnectServices.getSmartConnectSettings();
      console.log("res : ", res);
      if (!res?.success) {
        return rejectWithValue(res?.message || "Failed to fetch settings");
      }
      return res?.data || {};
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Internal Server Issue.",
      );
    }
  },
);

export const saveSmartConnectSettings = createAsyncThunk(
  "smartConnectSettings/save",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await smartConnectServices.saveSmartConnectSettings(payload);
      if (!res?.success) {
        return rejectWithValue(res?.message || "Failed to save settings");
      }
      return res?.data || {};
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Some Internal Server Issue.",
      );
    }
  },
);

export const createSmartConnectSetting = createAsyncThunk(
  "smartConnectSettings/create",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await smartConnectServices.createSmartConnectSettings(
        payload,
      );
      if (!res?.success) {
        return rejectWithValue(res?.message || "Failed to create settings");
      }
      return res?.data || {};
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Some Internal Server Issue.",
      );
    }
  },
);

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const smartConnectSettings = createSlice({
  name: "smartConnectSettings",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSmartConnectSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSmartConnectSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getSmartConnectSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const smartConnectSettingsReducer = smartConnectSettings.reducer;
